import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function AboutUs(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>Sobre nós</h2>
            <p className={classes.description}>Melhor do que poder ir onde quiser, é escolher quanto vc quer pagar.</p>
            <p className={classes.description}>
              O Ambulancia é o aplicativo que chegou para revolucionar o mercado de mobilidade urbana. 
            </p>
            <p className={classes.description}>
              Ele não cobra porcentagem por corrida dando maior flexibilidade para o motorista e passageiro poderem negociar o valor da corrida.
              O Funcionamento é bem simples.
            </p>
            <p className={classes.description}>
              O motorista paga um pequeno valor fixo mensal pelo uso da plataforma!
            </p>
            <p className={classes.description}>
              O passageiro na hora de solicitar a corrida recebe uma previsão de valor da viagem com base nos valores praticados por outros aplicativos, mas o passageiro pode sugerir seu valor tanto para menos como para mais,
              O motorista consegue visualizar em seu aplicativo as chamadas na sua região, com informações de endereço, distância, foto do passageiro e forma de pagamento. E escolher qual viagem melhor lhe convém.
            </p>
            <p className={classes.description}>
              Mas O mais legal de tudo é que o Ambulancia não está somente nas grandes cidades como outros aplicativos, ele funciona em qualquer lugar do Brasil, basta ter um prestador de serviço e um passageiro próximos, ele ainda tem a função Moto Táxi e Delivery,
              mas atenção. Alguns serviços depende da legislação da sua cidade para poderem serem usados.
            </p>
            <p className={classes.description}>
              Escolha seu Destino, escolha quanto vc quer pagar, escolha um aplicativo brasileiro.
            </p>
            <p className={classes.description}>
              Escolha o que for melhor pra você.
            </p>
            <p className={classes.description}>
              Ambulancia.
            </p>
            <br/>
        </div>
        </div>

      <Footer />
    </div>
  );
}
